export default class YoutubeLink {

    constructor($view) {

        this.$view = $view;
        this.youtubeLink = this.$view.attr('href');
        this.loadModalLink = this.$view.data('modal-link');
        this.bind();

    }

    bind(){
        this.$view.on('click', (e) => {
           e.preventDefault();
            let $this = $(e.target);
            HegydCore.initRemoteModal('#modal',this.loadModalLink);
        });
    }
}